import classNames from 'classnames'
import * as React from 'react'
import { Col, FormGroup, Input, InputProps, Label } from 'reactstrap'
import { ColumnProps } from 'reactstrap/lib/Col'

type OnChangeHandler = (newValue: any) => void

export interface ILabelColumnSize {
  xs?: ColumnProps
  sm?: ColumnProps
  md?: ColumnProps
  lg?: ColumnProps
  xl?: ColumnProps
  pr?: string | number
}

interface IFormGroupRendererProps extends InputProps {
  label?: React.ReactNode
  labelText?: string
  labelColSizes?: ILabelColumnSize
  onChange?: OnChangeHandler
}

export default class FormGroupRenderer extends React.PureComponent<
  IFormGroupRendererProps
> {
  public static defaultProps: Partial<IFormGroupRendererProps> = {
    labelColSizes: {
      md: 4,
      pr: 4,
      xl: 3,
    },
  }

  public render() {
    const {
      className,
      style,
      label,
      labelText,
      labelColSizes,
      children,
      onChange,
      ...otherProps
    } = this.props

    return (
      <FormGroup
        className={classNames('row align-items-baseline', className)}
        style={style}
      >
        <Col
          className={
            labelColSizes && labelColSizes.pr
              ? `col-pr-${labelColSizes.pr}`
              : ''
          }
          hidden={label || labelText ? false : true}
          xs={labelColSizes!.xs}
          sm={labelColSizes!.sm}
          md={labelColSizes!.md}
          lg={labelColSizes!.lg}
          xl={labelColSizes!.xl}
        >
          {label ? label : <Label className='mb-0'>{labelText}</Label>}
        </Col>
        <Col>
          {!children ? this._renderInput(otherProps, onChange) : children}
        </Col>
      </FormGroup>
    )
  }

  private _renderInput(props: InputProps, onChange?: OnChangeHandler) {
    return (
      <Input
        onChange={(e) => {
          if (onChange) {
            props.type === 'number'
              ? onChange(e.target.valueAsNumber)
              : onChange(e.target.value)
          }
        }}
        onKeyPress={(e) => {
          // This is done because Safari does not handle <input type='number' /> correctly when a comma or letter
          // is typed into the number input, it clears the value instead of preventing the character from being entered
          if (props.type === 'number' && !/[0-9\\.]/.test(e.key)) {
            e.preventDefault()
            e.stopPropagation()
          }
        }}
        {...props}
      />
    )
  }
}
